// import { Tabs, TabsList, TabsTrigger, TabsContent } from "@radix-ui/react-tabs";
import { Amplify } from "aws-amplify";
// import { useState } from "react";
import LoginTab from "./LoginTab";
// import RegisterTab from "./RegisterTab";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,

      loginWith: {
        username: true,
        email: true,
      },

      userAttributes: {
        given_name: {
          required: true,
        },
        family_name: {
          required: true,
        },
      },

      signUpVerificationMethod: "code",

      passwordFormat: {
        minLength: 8,
        requireUppercase: true,
        requireLowercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    secure: import.meta.env.MODE.includes("local") ? false : true,
    sameSite: "strict",
  }),
);

export const Authenticator = ({
  // defaultTab = "login",
  defaultUsername,
  defaultPassword,
}: {
  defaultTab?: "login" | "register";
  defaultUsername?: string;
  defaultPassword?: string;
}) => {
  // const [activeTab, setActiveTab] = useState<"login" | "register">(defaultTab);

  return (
    <div>
      {/* <Tabs
        defaultValue={defaultTab}
        onValueChange={(value) => setActiveTab(value as "login" | "register")}
      > */}
      {/* <TabsList className="grid grid-cols-2 w-full">
          <TabsTrigger
            style={{ cursor: "pointer" }}
            value="login"
            className={`w-full ${activeTab === "login" ? "font-bold" : ""}`}
          >
            Login
          </TabsTrigger>
          <TabsTrigger
            style={{ cursor: "pointer" }}
            value="register"
            className={`w-full ${activeTab === "register" ? "font-bold" : ""}`}
          >
            Register
          </TabsTrigger>
        </TabsList> */}

      {/* <TabsContent value="login"> */}
      <LoginTab
        defaultUsername={defaultUsername}
        defaultPassword={defaultPassword}
      />
      {/* </TabsContent> */}
      {/* <TabsContent value="register">
          <RegisterTab />
        </TabsContent> */}
      {/* </Tabs> */}
    </div>
  );
};
